module.exports = __webpack_public_path__ + "assets/logo.1f6d15aa.svg";